import React from "react";
import EnrollmentInsights from "./enrollmentInsights/EnrollmentInsights";
import { AreaChart, DonutChart, MultiBarChart } from "../../../../../../shared";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Backdrop } from "@material-ui/core";
import { ThreeCircles } from "react-loader-spinner";

import "./specificEnrollmentGraphicalInsights.css";
import { BenifitSummarySpecificEnrollmentGraphicalInsights } from "../../../../../../../@types/components/enrollmentTabSection.types";

const backdropStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: "#fff",
			position: "absolute"
		}
	})
);

const SpecificEnrollmentGraphicalInsights: React.FC<BenifitSummarySpecificEnrollmentGraphicalInsights> = ({
	cardDataProps,
	donutChartProps,
	areaChartProps,
	loading,
	multiBarChartData
}) => {
	const {
		totalPremium,
		totalEligibleEmployees,
		totalActiveBenefit,
		totalSubmittedEnrollment,
		totalWaivedEnrollment
	} = cardDataProps;
	const { data, options } = donutChartProps;
	const { areaData } = areaChartProps;

	const backdropClasses = backdropStyles();

	return (
		<div className="specific-enrollment-graphical-insights" id="specific-enrollment-graphical-insights">
			<div
				className="specific-enrollment-tab-section-information"
				id="specific-enrollment-tab-section-information"
			>
				{cardDataProps && (
					<EnrollmentInsights
						totalPremium={totalPremium}
						totalEligibleEmployees={totalEligibleEmployees}
						totalActiveBenefit={totalActiveBenefit}
						totalSubmittedEnrollment={totalSubmittedEnrollment}
						totalWaivedEnrollment={totalWaivedEnrollment}
					/>
				)}
			</div>

			<div
				className="specific-enrollment-tab-section-donut-chart"
				id="specific-enrollment-tab-section-donut-chart"
			>
				{donutChartProps ? <DonutChart data={data as any} options={options} /> : <></>}
			</div>
			<div className="specific-enrollment-tab-section-area-and-histogram-chart">
				<div
					className="specific-enrollment-tab-section-area-chart"
					id="specific-enrollment-tab-section-area-chart"
				>
					{areaChartProps ? <AreaChart areaData={areaData as unknown as any} /> : <></>}
				</div>
				<div
					className="specific-enrollment-tab-section-histogram-chart"
					id="specific-enrollment-tab-section-histogram-chart"
				>
					<MultiBarChart multiBarChartData={multiBarChartData} />
					<div className="static-year-text">
						<strong>For the year </strong>2026
					</div>
				</div>
			</div>
			<Backdrop className={backdropClasses.backdrop} open={loading}>
				<ThreeCircles
					height="100"
					width="100"
					color="#4fa94d"
					wrapperStyle={{}}
					wrapperClass=""
					visible={true}
					ariaLabel="three-circles-rotating"
					outerCircleColor=""
					innerCircleColor=""
					middleCircleColor=""
				/>
			</Backdrop>
		</div>
	);
};

export default SpecificEnrollmentGraphicalInsights;
